import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionWithdrawAndUnstakeComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionWithdrawAndUnstake"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <path d="M7 4.66675L7 9.33341" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33329 7L6.99996 9.33333L4.66663 7" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const TransactionWithdrawAndUnstake = withIcon(TransactionWithdrawAndUnstakeComponent);
